import { RingLoader } from "react-spinners";
import "./style.css";
export default function Loader() {
  return (
    <div className="loader">
      <RingLoader size={200} color="black" />
    </div>
  );
}
